import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';
import ShopServiceModel from '@/models/ShopServiceModel';

@model.cacheDuration()
@model.urnResource('product_template_status')
@doc.path('/product_template_statuses/{?id}')
export default class ProductTemplateStatusModel extends ShopServiceModel {
	private declare _tsFilters: {
		'reference': Shop_ProductTemplateStatusReference;
	};

	private declare _tsSorts: {
		'id': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Shop_ProductTemplateStatusReference;

	public get color() {
		switch (this.reference) {
			case 'disabled':
				return 'red';
			case 'enabled':
				return 'green';
			case 'in_creation':
				return 'blue';
		}
	}
}
